import UniteDisclaimerBlockView from './View';

export const UniteDisclaimerBlockEdit = (props) => {
  return <UniteDisclaimerBlockView {...props} />;
};

export default UniteDisclaimerBlockEdit;
